/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-curly-brace-presence */
import { ImageIcon } from '@saleshandy/design-system';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Images } from '../../../../shared/app-constants';
import { OverlayTooltip } from '../../../../shared/design-system/components/overlay';
import useFirstEffect from '../../../../shared/hooks/useFirstEffect';
import { SearchIcon } from '../../../../shared/svg';
import { accessibleOnClick } from '../../../../shared/utils/accessible-on-click';
import { RootState } from '../../../../store/root-reducer';
import { setShowAiSearchPopup } from '../../lead-slice';
import { FilterComponentType, LeadFinderTabKey } from '../../type';

type KeywordInputComponentProps = {
  handleQuery?: (value: any) => void;
  keywordInputRef?: React.RefObject<HTMLInputElement>;
  onHandleQuery?: (value: string) => void;
  activeTabKey: any;
};

const KeywordInputComponent: React.FC<KeywordInputComponentProps> = ({
  handleQuery = () => {},
  keywordInputRef,
  onHandleQuery = null,
  activeTabKey,
}) => {
  // ** REDUX Hooks
  const dispatch = useDispatch();
  const showAiSearchPopup = useSelector(
    (state: RootState) => state?.leads?.showAiSearchPopup || false,
  );

  // eslint-disable-next-line no-restricted-globals
  const queryParams = new URLSearchParams(location?.search);
  const [search, setSearch] = useState(queryParams.get('keyword') || '');

  // ** Handlers
  const openAiSearchPopup = useCallback(() => {
    if (!showAiSearchPopup) {
      dispatch(setShowAiSearchPopup(true));
    }
  }, [dispatch, showAiSearchPopup]);

  const handlePreQuery = (value = '') => {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      // If the trimmed value is empty, don't proceed with the API call
      return;
    }

    if (onHandleQuery) {
      onHandleQuery(value);
    }

    handleQuery({
      filterKey: 'keyword',
      filterValue: value,
      filterType: FilterComponentType.SEARCH_INPUT,
    });
  };

  const handleSearchTermValidationOnEnter = (e) => {
    if (e.keyCode === 13) {
      const trimmedValue = e.target?.value?.trim();

      if (!trimmedValue) {
        // If the trimmed value is empty, don't proceed with the API call
        return;
      }

      setSearch(trimmedValue);
      handlePreQuery(trimmedValue);
    }
  };

  useFirstEffect(() => {
    setSearch(queryParams.get('keyword') || '');
    // eslint-disable-next-line no-restricted-globals
  }, [location?.search]);

  return (
    <>
      <div>
        <div className="auto-search-container">
          <span className="search-icon">
            <SearchIcon width={16} height={16} />
          </span>

          <input
            ref={keywordInputRef}
            type="text"
            className="auto-search-input-saved"
            onChange={(e) => setSearch(e?.target?.value)}
            onKeyDown={handleSearchTermValidationOnEnter}
            value={search}
            placeholder="Search"
          />

          {search ? (
            <span
              onClick={() => {
                setSearch('');
              }}
              className="clear-icon"
            >
              <i className="sh-close-o" />
            </span>
          ) : (
            activeTabKey === LeadFinderTabKey.PEOPLE_TAB && (
              <OverlayTooltip
                text={
                  <>
                    Search using AI
                    <span className="auto-search-tooltip-beta">Beta</span>
                  </>
                }
                className="auto-search-tooltip"
              >
                <div
                  className="auto-search-shortkey-icon"
                  {...accessibleOnClick(openAiSearchPopup)}
                >
                  <ImageIcon
                    src={Images.Stars}
                    width={16}
                    height={16}
                    alt="stars"
                  />
                </div>
              </OverlayTooltip>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default KeywordInputComponent;
